import 'vite/modulepreload-polyfill';
import './scss/main.scss';
import './ts/utils';

import { lastUpdateHandlers, replaceTags } from '@/ts/utilities';
import { $store } from '@/ts/store';
import { DEBUG_MODE } from '@/ts/enums';
import { Components } from '@/fragments/components';
import { Resolver } from '@/ts/utils/resolver/resolver';
import '@/ts/utils/animations/counter';
export const resolve = new Resolver();

$store.setKey('debugLevel', DEBUG_MODE.NOTICE);

document.addEventListener('DOMContentLoaded', () => {
    Components();
    lastUpdateHandlers();
    replaceTags();
});

//Signal async libraries to fire up as the app is ready
document.dispatchEvent(new Event('cactusBootstrapped'));
